import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SingleToastService, StackedToastService } from '@rtr-factory/ui/toast';
import { tap } from 'rxjs/operators';
import { toastActions } from './toast.actions';

@Injectable()
export class ToastEffects {
  private actions$ = inject(Actions);
  private singleToastService = inject(SingleToastService);
  private stackedToastService = inject(StackedToastService);

  showStackedToast$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(toastActions.showStackedToast),
        tap(({ text, translationValues }) => this.stackedToastService.showToast(text, translationValues)),
      ),
    { dispatch: false },
  );

  showSingleToast$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(toastActions.showSingleToast),
        tap(({ text, toastType, translationValues }) =>
          this.singleToastService.showToast(text, toastType, translationValues),
        ),
      ),
    { dispatch: false },
  );
}
